<template>
  <div class="py-5">
    <div class="container">
      <h1 class="fw-light">{{ $t('join_indiefy_records') }}</h1>
      <div class="row mt-4">
        <div class="col-md-6">
          <div class="bg-light text-dark p-2">
            <h2 class="fw-bold mb-0 h3">{{ $t('for_independent_artists') }}</h2>
          </div>
          <p class="mt-3">
            {{ $t('indiefy_records_description_1') }}<br/><br/>
            {{ $t('indiefy_records_description_2') }}<br/><br/>
            {{ $t('indiefy_records_description_3') }}
          </p>
          <p class="fw-bold text-dark">
            {{ $t('sending_demos') }}
          </p>
          <p>
            {{ $t('forget_about_demos') }}
          </p>
          <p class="text-center mt-4 mb-4">
            <router-link to="/login?from=record_label" class="btn btn-lg btn-success">
              {{ $t('distribute_now') }}
            </router-link>
          </p>
        </div>
        <div class="col-md-6 text-right">
          <img src="https://assets.indiefy.net/blog-images/1566923637332.jpg" alt="Indiefy Records" class="playlist-covers">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LandingLabel',
  data: function () {
    return {
    }
  },
  methods: {
  },
  created: function () {
    window.document.title = this.$t('indiefy_records_title') + ' | Indiefy'
    window.$('meta[name="description"]').attr('content', this.$t('indiefy_records_description'))
    window.$('meta[property="og:description"]').attr('content', this.$t('indiefy_records_description'))
  },
  mounted: function () {
    setTimeout(() => {
      window.prerenderReady = true
    }, 100)
  }
}
</script>
<style lang="scss" scoped>
.playlist-covers {
  width: 90%;
}
</style>



// WEBPACK FOOTER //
// src/components/LandingLabel.vue